// BNS MARKETPLACE
//  - Buy from Marketplace.  Transfer BNS NFT from escrow contract principal to buyer.

import { useConnect } from '@stacks/connect-react';
import { StacksMainnet } from '@stacks/network';
import {} from '@stacks/bns';
import {
  AnchorMode,
  PostConditionMode,
  bufferCVFromString,
  NonFungibleConditionCode,
  makeContractNonFungiblePostCondition,
  createAssetInfo,
  tupleCV,
} from '@stacks/transactions';
import { userSession } from './ConnectWallet';

const BuyFromMarketplace = () => {
  const { doContractCall } = useConnect();

  function transferBnsNameFromContractPrincipal() {
    // To Do : before proceeding, check valid stxAddress, bns name and namespace. then display UI error message.

    const bnsContractAddress = 'SP000000000000000000002Q6VF78';
    const bnsContractName = 'bns';
    const bnsNftName = 'names'; //BNS NFT name
    //const bnsBuyer = userSession.loadUserData().profile.stxAddress.mainnet; //this is the tx-sender. buyer of BNS and future owner.
    const bnsTransferPostConditionCode = NonFungibleConditionCode.DoesNotOwn; //DoesNotOwn = owner sent NFT (BNS)

    const bnsAssetInfo = createAssetInfo(
      bnsContractAddress,
      bnsContractName,
      bnsNftName
    );

    const bnsAssetInfoTokenID = tupleCV({
      namespace: bufferCVFromString('stx'), //(bnsNamespaceContext). name hardcoded for hackathon purposes.
      name: bufferCVFromString('101bnstest0002'), // (bnsNameContext),
    });

    const bnsTransferPostCondition = makeContractNonFungiblePostCondition(
      'SP33D1W6D1Q2ESQ72BM64D356TC5SFZESR5TGPJ9F', //current BNS owner, the marketplace contract principal. giving it up and post-condition makes sure of that.
      'bns-marketplace-v02', //contract name. the marketplace contract.
      bnsTransferPostConditionCode,
      bnsAssetInfo,
      bnsAssetInfoTokenID
    );

    doContractCall({
      network: new StacksMainnet(),
      anchorMode: AnchorMode.Any,
      contractAddress: 'SP33D1W6D1Q2ESQ72BM64D356TC5SFZESR5TGPJ9F', //bnsContractAddress, bns-marketplace
      contractName: 'bns-marketplace-v02', //bnsContractName,
      functionName: 'transfer-name-from-contract', //bnsFunctionNameTransfer,

      functionArgs: [
        bufferCVFromString('stx'), //(bnsNamespaceContext),  // name hardcoded for hackathon purposes
        bufferCVFromString('101bnstest0002'), //(bnsNameContext),
      ],

      postConditionMode: PostConditionMode.Deny,
      postConditions: [bnsTransferPostCondition],

      onFinish: (data) => {
        window //opens a new window, show transaction in Stacks Explorer
          .open(
            `https://explorer.stacks.co/txid/${data.txId}?chain=mainnet`,
            '_blank'
          )
          .focus();
        // need to do more fancy stuff here, like a pending txn spinning wheel
      },
      onCancel: () => {
        console.log('onCancel:', 'Transaction was canceled');
      },
    });
  }

  if (!userSession.isUserSignedIn()) {
    return; // return an empty component if user has not signed-in yet.
  }

  return (
    <div>
      <p>-o-</p>
      <p>For this demo, name 101bnstest0002.stx was hardcoded.</p>
      <button
        className="Connect"
        onClick={() => transferBnsNameFromContractPrincipal()}
      >
        Buy from BNS Marketplace
      </button>
    </div>
  );
};

export default BuyFromMarketplace;
